import React from 'react';
import { Popover, Tabs } from 'antd';
import changeHistory from '../../../inventory-change-history';
import classnames from 'classnames';

// tagStyle1: 背景#E5E5E5 和 圆角
export const RuleTagRender = ({ rules = [], tagStyle1 = false }) => {
  const clsname = classnames('category-inventory-rule-tag', { 'tag-style1': tagStyle1 });

  return (
    <>
      {rules.map((item, index) => {
        if (item.type == 1 || item.type == 2) {
          return (
            <div className={clsname} key={index}>
              {item.type == 1 ? '类目' : '部门'}：{item.value.join('，')}
            </div>
          );
        }
        return item.value && item.value.length > 0 ? (
          <span key={index}>
            {item.value.map((ele) => (
              <div className={clsname} key={ele}>
                {ele}
              </div>
            ))}
          </span>
        ) : null;
      })}
    </>
  );
};

export const SubRuleTabs = ({ rules = [], activityId }) => {
  return rules?.length > 0 ? (
    <Tabs type="card" size="small">
      {rules.map((ele) => (
        <Tabs.TabPane key={ele.ruleId} tab={ele.ruleName}>
          <div style={{ maxHeight: 150, overflow: 'scroll' }}>
            <RuleTagRender rules={ele.ruleDetails} />
          </div>
        </Tabs.TabPane>
      ))}
    </Tabs>
  ) : null;
};

export const RuleTabs = ({ rules = [] }) => {
  return (
    rules?.length > 0 && (
      <Tabs size="small">
        {rules.map((item) => (
          <Tabs.TabPane key={item.subStrategyId} tab={item.subStrategyName}>
            <SubRuleTabs rules={item.rules} />
          </Tabs.TabPane>
        ))}
      </Tabs>
    )
  );
};

export const PopoverRule = (props) => {
  const { rules = [], placement = 'bottom', haveRuleUpdate, activityId, inventoryInfo, ...res } = props;
  const PopoverContent = () => {
    if (!rules?.length) return null;
    return <RuleTabs rules={rules} />;
  };

  return (
    <Popover
      content={<PopoverContent />}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>货盘规则明细</span>
          {!!haveRuleUpdate && <a onClick={() => changeHistory.show({ activityId, inventoryInfo })}>更新记录</a>}
        </div>
      }
      placement={placement}
      overlayInnerStyle={{ width: 535 }}
      {...res}
    >
      {props.children}
    </Popover>
  );
};

const RenderHP_rule = ({ rules = [], extra }) => {
  if (!rules?.length) return null;
  return (
    <div className="category-inventory-table-render-HP-rule">
      <div className="__first-rule-list">
        <RuleTagRender rules={rules} />
      </div>
      {extra}
    </div>
  );
};

export default RenderHP_rule;
